import { Component, OnInit } from '@angular/core';
import {environment} from "@env/environment";

@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  public version: string;
  public fecha: string;
  constructor() {}

  ngOnInit() {
    this.version = environment.version.version;
    this.fecha = environment.version.fecha;
  }

}
